import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllPacakges = async (data) => {
  try {
    const res = await request.post(Constants.get_all_packages_api_url, data);
    if (res) {
      return res?.data;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
export const getSupportedLocations = async (data) => {
  try {
    const res = await request.post(
      Constants.get_supported_locations_api_url,
      data
    );
    if (res) {
      return res?.data;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
